import { render, staticRenderFns } from "./BrakeDisk.vue?vue&type=template&id=56e72534"
import script from "./BrakeDisk.vue?vue&type=script&lang=js"
export * from "./BrakeDisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports